import { Loader, } from '@googlemaps/js-api-loader';


const load = async () => {
  const loader = new Loader({
    apiKey: process.env.VUE_APP_GMAPS_API_KEY,
    version: 'weekly',
    region: 'pt-BR',
    libraries: ['places',],
  },);

  /* Não carregar duas vezes */
  if (!window?.google?.maps?.Map) {
    await loader.load();
    load();
    return;
  }

  return window.google;
};

export default {
  install (Vue,) {
    Vue.prototype.$googleMaps = {
      load,
    };
  },
};
